var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearchIcon = function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57693 1.66663C4.76054 1.66663 1.66675 4.76042 1.66675 8.57681C1.66675 12.3932 4.76054 15.487 8.57693 15.487C10.2085 15.487 11.708 14.9215 12.8902 13.9759L17.2476 18.3333L18.3334 17.2475L13.976 12.8901C14.9216 11.7079 15.4871 10.2084 15.4871 8.57681C15.4871 4.76042 12.3933 1.66663 8.57693 1.66663ZM8.57693 3.20222C11.5452 3.20222 13.9515 5.6085 13.9515 8.57681C13.9515 11.5451 11.5452 13.9514 8.57693 13.9514C5.60863 13.9514 3.20234 11.5451 3.20234 8.57681C3.20234 5.6085 5.60863 3.20222 8.57693 3.20222Z",
    fill: "#999999"
  })));
};
export default SvgSearchIcon;